import { JsonConverter, JsonObject, JsonProperty } from "ta-json";

import { MinimalSchemaRelationCardinalityConverter } from "../../converters/minimal-schema-relation-cardinality-converter";
import { RelationCardinality, RelationRole } from "../base";

@JsonObject()
export class RelationData {
    @JsonProperty("name")
    name: string;

    @JsonProperty("cardinality")
    @JsonConverter(MinimalSchemaRelationCardinalityConverter)
    cardinality: RelationCardinality;

    @JsonProperty("role")
    role: RelationRole;

    constructor(init?: Partial<RelationData>) {
        Object.assign(this, init);
    }
}
